/** App selections kept across a tab refresh (hooks/useSessionState). */
export const SESSION_STATE_PREFIX = 'neoprof:ui:';

export const SESSION_STATE_KEY = Object.freeze({
  EDITING_STUDENT: 'editingStudent',
  EDITING_FAMILY: 'editingFamily',
  STUDENT_DETAIL: 'studentDetail',
  STUDENT_DETAIL_TAB: 'studentDetailTab',
  FAMILY_DETAIL: 'familyDetail',
  INVOICE_FAMILY: 'invoiceFamily',
  PAYMENT_FAMILY: 'paymentFamily',
  SCHEDULE_PREFILL: 'schedulePrefill',
  PENDING_STUDENT_FAMILY: 'pendingStudentFamilyId',
  STATS_TAB: 'statsActiveTab',
});
